export default "__VITE_ASSET__CGIx6aSg__"